<template>
	<div id="newQianniuExam">
		<div class="el-tabs el-tabs--left">
			<div class="el-tabs__header is-left">
				<div class="el-tabs__nav-wrap is-left">
					<div class="el-tabs__nav-scroll">
						<div class="el-tabs__nav is-left">
							<div class="el-tabs__active-bar is-left" style="height: 50px; transform: translateY(0px);"></div>
							<div id="tab-first" class="el-tabs__item js-tab is-left is-active">
								<div class="tab-slot">
									<p class="title">1、登录千牛工作台</p>
								</div>
							</div>
							<div id="tab-second" class="el-tabs__item js-tab is-left">
								<div class="tab-slot">
									<p class="title">2、切换状态</p>
								</div>
							</div>
							<div id="tab-third" class="el-tabs__item js-tab is-left">
								<div class="tab-slot">
									<p class="title">3、接待顾客</p>
								</div>
							</div>
							<div id="tab-four" class="el-tabs__item js-tab is-left">
								<div class="tab-slot">
									<p class="title">4、设置自动回复</p>
								</div>
							</div>
							<div id="tab-five" class="el-tabs__item js-tab is-left">
								<div class="tab-slot">
									<p class="title">5、添加插件</p>
								</div>
							</div>
							<div id="tab-six" class="el-tabs__item js-tab is-left">
								<div class="tab-slot">
									<p class="title">6、快捷短语的使用和导入</p>
								</div>
							</div>
							<div id="tab-seven" class="el-tabs__item js-tab is-left">
								<div class="tab-slot">
									<p class="title">7、状态识别</p>
								</div>
							</div>
							<div id="tab-eight" class="el-tabs__item js-tab is-left">
								<div class="tab-slot">
									<p class="title">8、转接功能</p>
								</div>
							</div>
							<div id="tab-nine" class="el-tabs__item js-tab is-left">
								<div class="tab-slot">
									<p class="title">9、商品插件学习</p>
								</div>
							</div>
							<div id="tab-ten" class="el-tabs__item js-tab is-left">
								<div class="tab-slot">
									<p class="title">10、订单插件学习</p>
								</div>
							</div>
							<div id="tab-eleven" class="el-tabs__item js-tab is-left">
								<div class="tab-slot">
									<p class="title">11、新建任务</p>
								</div>
							</div>
							<div id="tab-twelve" class="el-tabs__item js-tab is-left">
								<div class="tab-slot">
									<p class="title">12、退出千牛</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="el-tabs__content">
				<div id="tab-first-content" class="el-tab-pane">
					<div id="stoptip-first" class="stoptip">
						<div class="tip">
							<span class="el-icon-success"></span>
							<p>
								<a class="startstudy" @click="startStudy">开始实操练习</a>
							</p>
						</div>
					</div>
					<div id="content-first" class="content">
						<div class="con-left">
							<!--双击图标-->
							<div v-show="isShowQnIcon" class="qnbox">
								<img class="qnbg" src="/tjkStudy/static/newqianniu/qnbg.jpg" />
								<img class="qnicon01" src="/tjkStudy/static/newqianniu/qnicon01.png" @click="showLoginImg" />
							</div>
							<div v-show="isShowQnIcon2" class="qnbox">
								<img class="qnbg" src="/tjkStudy/static/newqianniu/qnbg.jpg" />
								<img class="qnicon02" src="/tjkStudy/static/newqianniu/qnicon02.png" @dblclick="showLoginImg2" />
							</div>
							<!--登录-->
							<div v-show="isShowLoginImg" class="login">
					      <img src="/tjkStudy/static/newqianniu/login.jpg" class="homeImg">
					      <input type="text" v-model.trim="name" class="name" placeholder="请输入账号" />
					      <input type="password" v-model.trim="password" autocomplete="new-password" class="password" placeholder="请输入密码" />
					      <div class="logIn" @click="loginIn"></div>
					    </div>
							<!--获取随机码-->
							<div v-show="isShowRnd" class="loginrnd">
								<img src="/tjkStudy/static/newqianniu/loginrnd.jpg" class="rndImg">
					      <input type="text" v-model.trim="rnd" class="rnd" placeholder="请输入短信验证码" />
					      <div class="logInRnd" @click="loginInRnd"></div>
							</div>
							<!--登录成功点击会话图标-->
							<div v-show="isShowLoginIndex" class="jdbox">
								<img class="jdimg" src="/tjkStudy/static/newqianniu/jdicon.jpg" />
								<div class="jdicon" @click="enterJd"></div>
							</div>
							<!--完成-->
							<div v-show="isShowLoginIndexTwo" class="indexbox">
								<img class="indeximg" src="/tjkStudy/static/newqianniu/gq.jpg" />
							</div>
						</div>
						<div class="con-right">
							<h3>
								<span class="line"></span>
								提示
							</h3>
							<!--双击图标-->
							<p v-if="isShowQnIcon || isShowQnIcon2">请点击<span style="color: red;font-weight:bold;">左侧练习场</span>中的千牛图标进行登录</p>
							<!--登录-->
							<template v-if="isShowLoginImg">
								<p>首次登录需要找主管获取账号密码。本次模拟练习，请点击下方按钮获取账号密码。</p>
								<el-button type="primary" @click="showPassword = true">获取账号密码</el-button>
								<template v-if="showPassword">
									<p>账号（<span style="color: red;font-weight:bold;">账号中间的冒号是英文冒号</span>）：</p>
									<p><span style="color: red;font-weight:bold;">淘金客服:001</span></p>
									<p>密码：</p>
									<p><span style="color: red;font-weight:bold;">TJ2019</span></p>
								</template>
							</template>
							<!--获取随机码-->
							<template v-if="isShowRnd">
								<p>首次登录需要找主管获取短信验证码。本次模拟练习，请点击下方按钮获取短信验证码。</p>
								<el-button type="primary" @click="showRnd = true">获取短信验证码</el-button>
								<template v-if="showRnd">
									<p>短信验证码：</p>
									<p><span style="color: red;font-weight:bold;">660220</span></p>
								</template>
							</template>
							<!--进入接待中心-->	
							<p v-if="isShowLoginIndex">请进入千牛接待中心</p>
						</div>
					</div>
					<div id="studytip-first" class="stoptip">
						<div class="tip">
							<span class="el-icon-success"></span>
							<p>实操通关，进入下一关吧</p>
							<p>
								<a class="startstudy" @click="studyNext('#tab-second', 2, 'second')">GO，下一关</a>
							</p>
						</div>
					</div>
				</div>
				<div id="tab-second-content" class="el-tab-pane" :class="{mynone: tabCurrent !== 'second'}">
					<div id="stoptip-second" class="stoptip">
						<div class="tip">
							<span class="el-icon-success"></span>
							<p>
								<a class="startstudy" @click="startStudy">开始实操练习</a>
							</p>
						</div>
					</div>
					<div id="content-second" class="content">
						<div class="con-left">
							<!--挂起-->
							<div v-show="!isShowWgq" class="gqbox">
								<img class="gqimg" src="/tjkStudy/static/newqianniu/gq.jpg" />
								<div class="gqbtn" @click="showGqImg = true"></div>
								<img v-show="showGqImg" class="qhimg" src="/tjkStudy/static/newqianniu/qh.png" />
								<div v-show="showGqImg" class="gqclick" @click="showWgqImg" />
							</div>
							<!-- 未挂起 -->
							<div class="wgqbox">
								<img v-show="isShowWgq" class="wgqimg" src="/tjkStudy/static/newqianniu/wgq.jpg" />
							</div>
						</div>
						<div class="con-right">
							<h3>
								<span class="line"></span>
								提示
							</h3>
							<p>请将状态切换为“<span style="color: red;font-weight:bold;">未挂起</span>”状态</p>
						</div>
					</div>
					<div id="studytip-second" class="stoptip">
						<div class="tip">
							<span class="el-icon-success"></span>
							<p>实操通关，进入下一关吧</p>
							<p>
								<a class="startstudy" @click="studyNext('#tab-third', 3, 'third')">GO，下一关</a>
							</p>
						</div>
					</div>
				</div>
				<div id="tab-third-content" class="el-tab-pane" :class="{mynone: tabCurrent !== 'third'}">
					<div id="stoptip-third" class="stoptip">
						<div class="tip">
							<span class="el-icon-success"></span>
							<p>
								<a class="startstudy" @click="startStudy">开始实操练习</a>
							</p>
						</div>
					</div>
					<div id="content-third" class="content">
						<div class="con-left">
							<!-- 接待顾客 -->
							<div class="jdgkbox">
								<img class="jiedaiimg" src="/tjkStudy/static/newqianniu/jiedai.jpg" />
								<div class="replyone">
									<p class='session'>
										<span class='user'>fanchaocdmc</span>
										<span class='time'>{{ time }}</span>
									</p>
									<p><span>在吗？</span></p>
								</div>
								<!-- 回复1 -->
								<template v-if="isShowOne">
									<el-input type="textarea" v-model.trim="jdnr" class="jiedaitextarea" @keydown.native="listenOne($event)"></el-input>
									<div class="jdbtn" @click="showJieDaiImgOne"></div>
								</template>
								<!-- 回复2 -->
								<template v-if="isShowTwo">
									<el-input type="textarea" v-model.trim="jdnr" class="jiedaitextarea" @keydown.native="listenTwo($event)"></el-input>
									<div class="jdbtn" @click="showJieDaiImgTwo"></div>
								</template>
								<!-- 回复3 -->
								<template v-if="isShowThree">
									<el-input type="textarea" v-model.trim="jdnr" class="jiedaitextarea" @keydown.native="listenThree($event)"></el-input>
									<div class="jdbtn" @click="showJieDaiImgThree"></div>
								</template>
								<!-- 回复4 -->
								<template v-if="isShowFour">
									<el-input type="textarea" v-model.trim="jdnr" class="jiedaitextarea" @keydown.native="listenFour($event)"></el-input>
									<div class="jdbtn" @click="showJieDaiImgFour"></div>
								</template>
							</div>
						</div>
						<div class="con-right">
							<h3>
								<span class="line"></span>
								提示
							</h3>
							<p v-if="isShowOne">请接待顾客，回复内容：<span style="color: red;font-weight:bold;">您好！欢迎光临，请问有什么可以帮到您？</span></p>
							<p v-if="isShowTwo">请接待顾客，回复内容：<span style="color: red;font-weight:bold;">亲亲，正常情况下大概3天左右能到哦！</span></p>
							<p v-if="isShowThree">请接待顾客，回复内容：<span style="color: red;font-weight:bold;">请问还有什么可以帮到您？</span></p>
							<p v-if="isShowFour">请接待顾客，回复内容：<span style="color: red;font-weight:bold;">好的，感谢亲亲的支持，祝您生活愉快</span></p>
						</div>
					</div>
					<div id="studytip-third" class="stoptip">
						<div class="tip">
							<span class="el-icon-success"></span>
							<p>实操通关，进入下一关吧</p>
							<p>
								<a class="startstudy" @click="studyNext('#tab-four', 4, 'four')">GO，下一关</a>
							</p>
						</div>
					</div>
				</div>
				<div id="tab-four-content" class="el-tab-pane" :class="{mynone: tabCurrent !== 'four'}">
					<div id="stoptip-four" class="stoptip">
						<div class="tip">
							<span class="el-icon-success"></span>
							<p>
								<a class="startstudy" @click="startStudy">开始实操练习</a>
							</p>
						</div>
					</div>
					<div id="content-four" class="content">
						<div class="con-left">
							<div class="zdhfbox">
								<img class="gqimg" v-show="isShowZdhficon || isShowZdhf01" src="/tjkStudy/static/newqianniu/gq.jpg" />
								<div class="zdhficon" v-show="isShowZdhficon" @click="showZdhf01"></div>
								<div class="zdhf01" v-show="isShowZdhf01">
									<img src="/tjkStudy/static/newqianniu/zdhf01.png" />
									<div class="zdhf01icon" @click="showZdhf02"></div>
								</div>
								<div class="zdhf02" v-show="isShowZdhf02">
									<img src="/tjkStudy/static/newqianniu/zdhf02.jpg" />
									<div class="zdhf02icon" @click="showZdhf03"></div>
								</div>
								<div class="zdhf02" v-show="isShowZdhf03">
									<img src="/tjkStudy/static/newqianniu/zdhf03.jpg" />
									<div class="zdhf03icon" @click="showZdhf04"></div>
								</div>
								<div class="zdhf02" v-show="isShowZdhf04">
									<img src="/tjkStudy/static/newqianniu/zdhf04.jpg" />
									<div class="zdhf04icon" @click="showZdhf05"></div>
								</div>
								<div class="zdhf02" v-show="isShowZdhf05">
									<img src="/tjkStudy/static/newqianniu/zdhf05.jpg" />
									<el-input class="zdhf05icon" v-model.trim="zdhf" type="textarea" :rows="10" ></el-input>
									<div class="zdhf05btn" @click="showZdhf06"></div>
								</div>
								<div class="zdhf02" v-show="isShowZdhf06">
									<img src="/tjkStudy/static/newqianniu/zdhf06.jpg" />
									<div class="zdhf06icon" @click="showZdhf07"></div>
								</div>
								<div class="zdhf02" v-show="isShowZdhf07">
									<img src="/tjkStudy/static/newqianniu/zdhf07.jpg" />
									<div class="zdhf07icon" @click="showZdhf08"></div>
								</div>
								<div class="zdhf02" v-show="isShowZdhf08">
									<img src="/tjkStudy/static/newqianniu/zdhf08.jpg" />
									<div class="zdhf08icon" @click="showZdhf09"></div>
								</div>
								<div class="zdhf02" v-show="isShowZdhf09">
									<img src="/tjkStudy/static/newqianniu/zdhf09.jpg" />
									<div class="zdhf09icon" @click="showZdhf10"></div>
								</div>
								<div class="zdhf02" v-show="isShowZdhf10">
									<img src="/tjkStudy/static/newqianniu/zdhf10.jpg" />
								</div>
							</div>
						</div>
						<div class="con-right">
							<h3>
								<span class="line"></span>
								提示
							</h3>
							<p>请新增一条内容为“<span style="color: red;font-weight:bold;">您好！欢迎光临，请问有什么可以帮到您？</span>”的自动回复，并设置成“<span style="color: red;font-weight:bold;">当天第一次收到买家消息时自动回复</span>”</p>
						</div>
					</div>
					<div id="studytip-four" class="stoptip">
						<div class="tip">
							<span class="el-icon-success"></span>
							<p>实操通关，进入下一关吧</p>
							<p>
								<a class="startstudy" @click="studyNext('#tab-five', 5, 'five')">GO，下一关</a>
							</p>
						</div>
					</div>
				</div>
				<div id="tab-five-content" class="el-tab-pane" :class="{mynone: tabCurrent !== 'five'}">
					<div id="stoptip-five" class="stoptip">
						<div class="tip">
							<span class="el-icon-success"></span>
							<p>
								<a class="startstudy" @click="startStudy">开始实操练习</a>
							</p>
						</div>
					</div>
					<div id="content-five" class="content">
						<div class="con-left">
							<div class="cjxxbox">
								<div class="cjxx" v-show="isShowCjxxicon">
									<img class="gqimg" src="/tjkStudy/static/newqianniu/gq.jpg" />
									<div class="cjxxicon" @click="showCjxx01"></div>
								</div>
								<div class="cjxx" v-show="isShowCjxx01">
									<img src="/tjkStudy/static/newqianniu/cjxx01.jpg" />
									<div class="cjxx01icon" @click="showCjxx02"></div>
								</div>
								<div class="cjxx" v-show="isShowCjxx02">
									<img src="/tjkStudy/static/newqianniu/cjxx02.jpg" />
									<div class="cjxx02icon" @click="showCjxx03"></div>
								</div>
								<div class="cjxx" v-show="isShowCjxx03">
									<img src="/tjkStudy/static/newqianniu/cjxx03.jpg" />
									<div class="cjxx03icon" @click="showCjxx04"></div>
								</div>
								<div class="cjxx" v-show="isShowCjxx04">
									<img src="/tjkStudy/static/newqianniu/cjxx04.jpg" />
									<div class="cjxx04icon" @mouseover="showCjxx05"></div>
								</div>
								<div class="cjxx" v-show="isShowCjxx05">
									<img src="/tjkStudy/static/newqianniu/cjxx05.jpg" />
									<div class="cjxx05icon" @click="showCjxx06"></div>
								</div>
								<div class="cjxx" v-show="isShowCjxx06">
									<img src="/tjkStudy/static/newqianniu/cjxx06.jpg" />
									<div class="cjxx06icon" @mouseover="showCjxx07"></div>
								</div>
								<div class="cjxx" v-show="isShowCjxx07">
									<img src="/tjkStudy/static/newqianniu/cjxx07.jpg" />
									<div class="cjxx07icon" @click="showCjxx08"></div>
								</div>
								<div class="cjxx" v-show="isShowCjxx08">
									<img src="/tjkStudy/static/newqianniu/cjxx08.jpg" />
									<div class="cjxx08icon" @mouseover="showCjxx09"></div>
								</div>
								<div class="cjxx" v-show="isShowCjxx09">
									<img src="/tjkStudy/static/newqianniu/cjxx09.jpg" />
									<div class="cjxx09icon" @click="showCjxx10"></div>
								</div>
								<div class="cjxx" v-show="isShowCjxx10">
									<img src="/tjkStudy/static/newqianniu/cjxx10.jpg" />
									<div class="cjxx10icon" @mouseover="showCjxx11"></div>
								</div>
								<div class="cjxx" v-show="isShowCjxx11">
									<img src="/tjkStudy/static/newqianniu/cjxx11.jpg" />
			            <div class="cjxx11icon" @click="showCjxx12"></div>
								</div>
			          <div class="cjxx" v-show="isShowCjxx12">
									<img src="/tjkStudy/static/newqianniu/cjxx12.jpg" />
			            <div class="cjxx12icon" @mouseover="showCjxx13"></div>
								</div>
			          <div class="cjxx" v-show="isShowCjxx13">
									<img src="/tjkStudy/static/newqianniu/cjxx13.jpg" />
			            <div class="cjxx13icon" @click="showCjxx14"></div>
								</div>
			          <div class="cjxx" v-show="isShowCjxx14">
									<img src="/tjkStudy/static/newqianniu/cjxx14.jpg" />
			            <div class="cjxx14icon" @mouseover="showCjxx15"></div>
								</div>
			          <div class="cjxx" v-show="isShowCjxx15">
									<img src="/tjkStudy/static/newqianniu/cjxx15.jpg" />
			            <div class="cjxx15icon" @click="showCjxx16"></div>
								</div>
			          <div class="cjxx" v-show="isShowCjxx16">
									<img src="/tjkStudy/static/newqianniu/cjxx16.jpg" />
			            <div class="cjxx16icon" @mouseover="showCjxx17"></div>
								</div>
			          <div class="cjxx" v-show="isShowCjxx17">
									<img src="/tjkStudy/static/newqianniu/cjxx17.jpg" />
			            <div class="cjxx17icon" @click="showCjxx18"></div>
								</div>
			          <div class="cjxx" v-show="isShowCjxx18">
									<img src="/tjkStudy/static/newqianniu/cjxx18.jpg" />
			            <div class="cjxx18icon" @mouseover="showCjxx19"></div>
								</div>
			          <div class="cjxx" v-show="isShowCjxx19">
									<img src="/tjkStudy/static/newqianniu/cjxx19.jpg" />
			            <div class="cjxx19icon" @click="showCjxx20"></div>
								</div>
			          <div class="cjxx" v-show="isShowCjxx20">
									<img src="/tjkStudy/static/newqianniu/cjxx20.jpg" />
								</div>
							</div>
						</div>
						<div class="con-right">
							<h3>
								<span class="line"></span>
								提示
							</h3>
							<p v-if="isShowCjxxTip">请调出一位最近联系人的对话</p>
							<template v-if="isShowCjxxTip01 || isShowCjxxTip02 || isShowCjxxTip03 || isShowCjxxTip04">
								<p>请依次完成以下操作：</p>
								<p>1、添加<span style="color: red;font-weight:bold;">“淘宝商品管理”</span>插件</p>
								<p>2、添加<span style="color: red;font-weight:bold;">“淘宝交易管理”</span>插件</p>
								<p>3、添加<span style="color: red;font-weight:bold;">“智能客服”</span>插件</p>
								<p>4、添加<span style="color: red;font-weight:bold;">“物流”</span>插件</p>
							</template>
							<p v-if="isShowCjxxTip05">请关闭旺旺插件中心</p>
						</div>
					</div>
					<div id="studytip-five" class="stoptip">
						<div class="tip">
							<span class="el-icon-success"></span>
							<p>实操通关，进入下一关吧</p>
							<p>
								<a class="startstudy" @click="studyNext('#tab-six', 6, 'six')">GO，下一关</a>
							</p>
						</div>
					</div>
				</div>
				<div id="tab-six-content" class="el-tab-pane" :class="{mynone: tabCurrent !== 'six'}">
					<div id="stoptip-six" class="stoptip">
						<div class="tip">
							<span class="el-icon-success"></span>
							<p>
								<a class="startstudy" @click="startStudy">开始实操练习</a>
							</p>
						</div>
					</div>
					<div id="content-six" class="content">
						<div class="con-left">
							<div class="kjdybox">
								<div class="kjdy" v-show="isShowKjdyicon">
									<img src="/tjkStudy/static/newqianniu/kjdy.jpg" />
									<div class="kjdyicon" @click="showKjdy01"></div>
								</div>
								<div class="kjdy" v-show="isShowKjdy01">
									<img src="/tjkStudy/static/newqianniu/kjdy01.jpg" />
									<div class="kjdy01icon" @mouseover="showKjdy02"></div>
								</div>
								<div class="kjdy" v-show="isShowKjdy02">
									<img src="/tjkStudy/static/newqianniu/kjdy02.jpg" />
									<div class="kjdy02icon" @click="showKjdy03"></div>
								</div>
								<div class="kjdy" v-show="isShowKjdy03">
									<img src="/tjkStudy/static/newqianniu/kjdy03.jpg" />
			            <input type="text" class="kjdy03input" v-focus="true" @keyup.enter="showKjdy04">
									<div class="kjdy03icon" @click="showKjdy04"></div>
								</div>
								<div class="kjdy" v-show="isShowKjdy04">
									<img src="/tjkStudy/static/newqianniu/kjdy04.jpg" />
								</div>
								<!-- 快捷编码练习 -->
								<div class="kjdy" v-if="isShowKjdy05">
									<img src="/tjkStudy/static/newqianniu/kjdy01.jpg" />
									<el-input type="textarea" v-model.trim="kjdy" class="kjdytextarea"></el-input>
									<img v-if="isShowKjdy06" class="kjdy05icon" src="/tjkStudy/static/newqianniu/kjdy08.png" @click="showKjdy05" />
								</div>
								<div class="kjdy" v-if="isShowKjdy07">
									<img src="/tjkStudy/static/newqianniu/kjdy03.jpg" />
			            <input type="text" class="kjdy03input" v-focus="true" @keyup.enter="showKjdy06">
									<div class="kjdy03icon" @click="showKjdy06"></div>
								</div>
								<div class="kjdy" v-if="isShowKjdy08">
									<img src="/tjkStudy/static/newqianniu/kjdy04.jpg" />
								</div>
								<!-- 导入 -->
								<div class="kjdy" v-if="isShowKjdy09">
									<img src="/tjkStudy/static/newqianniu/kjdy04.jpg" />
									<div class="kjdy04icon" @click="showKjdy07"></div>
								</div>
								<div class="kjdy" v-if="isShowKjdy10">
									<img src="/tjkStudy/static/newqianniu/kjdy05.jpg" />
									<div class="kjdy06icon">
										<input type="file" @change="tirggerFile($event)" class="btn-file" />
									</div>
								</div>
								<div class="kjdy" v-if="isShowKjdy11">
									<img src="/tjkStudy/static/newqianniu/kjdy06.jpg" />
									<div class="kjdy07icon" @click="showKjdy08"></div>
								</div>
								<div class="kjdy" v-if="isShowKjdy12">
									<img src="/tjkStudy/static/newqianniu/kjdy07.jpg" />
								</div>
							</div>
						</div>
						<div class="con-right">
							<h3>
								<span class="line"></span>
								提示
							</h3>
							<p v-if="isShowKjdyTip01">使用快捷短语操作练习：请采用鼠标左键点击快捷键的方式，给当前顾客发送一条结束语的快捷短语</p>
							<div v-if="isShowKjdyTip02">
								<p>使用快捷短语操作练习：</p>
								<p>请采用/+快捷编码的方式（例如：<span style="color: red;font-weight:bold;">/结束</span>），给当前顾客发送一条结束语的快捷短语</p>
							</div>
							<div v-if="isShowKjdyTip03">
								<p>导入快捷短语操作练习：</p>
								<p>请先下载下方的快捷短语表格，并保存在桌面上</p>
								<p><a @click="downloadKjdyFile">点击下载“快捷短语.csv”</a></p>
							</div>
							<div v-if="isShowKjdyTip04">
								<p>导入快捷短语操作练习：</p>
								<p>请将下载好的快捷短语表格导入到千牛上</p>
							</div>
						</div>
					</div>
					<div id="studytip-six" class="stoptip">
						<div class="tip">
							<span class="el-icon-success"></span>
							<p>实操通关，进入下一关吧</p>
							<p>
								<a class="startstudy" @click="studyNext('#tab-seven', 7, 'seven')">GO，下一关</a>
							</p>
						</div>
					</div>
				</div>
				<div id="tab-seven-content" class="el-tab-pane" :class="{mynone: tabCurrent !== 'seven'}">
					<div id="stoptip-seven" class="stoptip">
	          <div class="tip">
	            <span class="el-icon-success"></span>
	            <p>
	              <a class="startstudy" @click="startStudy">开始实操练习</a>
	            </p>
	          </div>
	        </div>
	        <div id="content-seven" class="content">
	          <div class="con-left">
	            <div class="ztsbbox">
	              <div class="ztsb" v-show="isShowZtsbicon">
	                <img src="/tjkStudy/static/newqianniu/ztsb.jpg" />
	                <div class="ztsbicon" @mouseover="showZtsb01"></div>
	              </div>
	              <div class="ztsb" v-show="isShowZtsb01">
	                <img src="/tjkStudy/static/newqianniu/ztsb01.jpg" />
	                <div class="ztsb01icon" @click="showZtsb02"></div>
	              </div>
	              <div class="ztsb" v-show="isShowZtsb02">
	                <img src="/tjkStudy/static/newqianniu/ztsb02.jpg" />
	                <div class="ztsb02icon" @mouseover="showZtsb03"></div>
	              </div>
	              <div class="ztsb" v-show="isShowZtsb03">
	                <img src="/tjkStudy/static/newqianniu/ztsb03.jpg" />
	                <div class="ztsb03icon" @click="showZtsb04"></div>
	              </div>
	              <div class="ztsb" v-show="isShowZtsb04">
	                <img src="/tjkStudy/static/newqianniu/ztsb04.jpg" />
	                <div class="ztsb04icon" @mouseover="showZtsb05"></div>
	              </div>
	              <div class="ztsb" v-show="isShowZtsb05">
	                <img src="/tjkStudy/static/newqianniu/ztsb05.jpg" />
	                <div class="ztsb05icon" @click="showZtsb06"></div>
	              </div>
	              <div class="ztsb" v-show="isShowZtsb06">
	                <img src="/tjkStudy/static/newqianniu/ztsb06.jpg" />
	              </div>
	          	</div>
	      		</div>
	          <div class="con-right">
	            <h3>
	              <span class="line"></span>
	              提示
	            </h3>
	            <p v-if="isShowZtsbTip01">状态识别：请将对话切换为“<span style="color: red;font-weight:bold;">已下单，未付款</span>”的顾客</p>
	            <p v-if="isShowZtsbTip02">状态识别：请将对话切换为“<span style="color: red;font-weight:bold;">已付款，未发货</span>”的顾客</p>
	            <p v-if="isShowZtsbTip03">状态识别：请将对话切换为“<span style="color: red;font-weight:bold;">已发货，未收货</span>”的顾客</p>
	          </div>
	        </div>
	        <div id="studytip-seven" class="stoptip">
	          <div class="tip">
	            <span class="el-icon-success"></span>
	            <p>实操通关，进入下一关吧</p>
	            <p>
	              <a class="startstudy" @click="studyNext('#tab-eight', 8, 'eight')">GO，下一关</a>
	            </p>
	          </div>
	        </div>
				</div>
				<div id="tab-eight-content" class="el-tab-pane" :class="{mynone: tabCurrent !== 'eight'}">
					<div id="stoptip-eight" class="stoptip">
	          <div class="tip">
	            <span class="el-icon-success"></span>
	            <p>
	              <a class="startstudy" @click="startStudy">开始实操练习</a>
	            </p>
	          </div>
	        </div>
	        <div id="content-eight" class="content">
	          <div class="con-left">
	            <div class="zjgnbox">
	              <div class="zjgn" v-show="isShowZjgnicon">
	                <img src="/tjkStudy/static/newqianniu/zjgn.jpg" />
	                <div class="zjgnicon" @click="showZjgn01"></div>
	            	</div>
	            	<div class="zjgn" v-show="isShowZjgn01">
	                <img src="/tjkStudy/static/newqianniu/zjgn01.jpg" />
	                <div class="zjgn01icon" @mouseover="showZjgn03"></div>
	              </div>
	              <div class="zjgn" v-show="isShowZjgn03">
	                <img src="/tjkStudy/static/newqianniu/zjgn03.jpg" />
	                <div class="zjgn03icon" @mouseover="showZjgn04"></div>
	              </div>
	              <div class="zjgn" v-show="isShowZjgn04">
	                <img src="/tjkStudy/static/newqianniu/zjgn04.jpg" />
	                <div class="zjgn04icon" @click="showZjgn05"></div>
	              </div>
	              <div class="zjgn" v-show="isShowZjgn05">
	                <img src="/tjkStudy/static/newqianniu/zjgn05.jpg" />
	              </div>
	            </div>
	          </div>
	          <div class="con-right">
	            <h3>
	              <span class="line"></span>
	              提示
	            </h3>
	            <p>转接功能操作练习：请将“<span style="color: red;font-weight:bold;">客户001</span>”转接给“<span style="color: red;font-weight:bold;">小红（贝拉）</span>”</p>
	          </div>
	      	</div>
	        <div id="studytip-eight" class="stoptip">
	          <div class="tip">
	            <span class="el-icon-success"></span>
	            <p>实操通关，进入下一关吧</p>
	            <p>
	              <a class="startstudy" @click="studyNext('#tab-nine', 9, 'nine')">GO，下一关</a>
	            </p>
	          </div>
	        </div>
				</div>
				<div id="tab-nine-content" class="el-tab-pane" :class="{mynone: tabCurrent !== 'nine'}">
					<div id="stoptip-nine" class="stoptip">
	          <div class="tip">
	            <span class="el-icon-success"></span>
	            <p>
	              <a class="startstudy" @click="startStudy">开始实操练习</a>
	            </p>
	          </div>
	        </div>
	        <div id="content-nine" class="content">
	          <div class="con-left">
	            <div class="tjgnbox">
	              <div class="tjgn" v-show="isShowTjgnicon">
	                <img src="/tjkStudy/static/newqianniu/tjgn.jpg" />
	                <div class="tjgnicon" @mouseover="showTjgn01"></div>
	              </div>
	              <div class="tjgn" v-show="isShowTjgn01">
	                <img src="/tjkStudy/static/newqianniu/tjgn01.jpg" />
	                <div class="tjgn01icon" @click="showTjgn02"></div>
	              </div>
	              <div class="tjgn" v-show="isShowTjgn02">
	                <img src="/tjkStudy/static/newqianniu/tjgn02.jpg" />
	                <div class="tjgn02icon" @click="showTjgn03"></div>
	              </div>
	              <div class="tjgn" v-show="isShowTjgn03">
	                <img src="/tjkStudy/static/newqianniu/tjgn03.jpg" />
	                <div class="tjgn03icon" @mouseover="showTjgn04"></div>
	              </div>
	              <div class="tjgn" v-show="isShowTjgn04">
	                <img src="/tjkStudy/static/newqianniu/tjgn04.jpg" />
	                <div class="tjgn04icon" @click="showTjgn05"></div>
	              </div>
	              <div class="tjgn" v-show="isShowTjgn05">
	                <img src="/tjkStudy/static/newqianniu/tjgn05.jpg" />
	                <input type="text" class="tjgn05input" v-focus="true" @keyup.enter="showTjgn06">
	                <div class="tjgn05icon" @click="showTjgn06"></div>
	              </div>
	              <div class="tjgn" v-show="isShowTjgn06">
	                <img src="/tjkStudy/static/newqianniu/tjgn06.jpg" />
	              </div>
	            </div>
	          </div>
	          <div class="con-right">
	            <h3>
	              <span class="line"></span>
	              提示
	            </h3>
	            <p>商品插件操作练习：请将<span style="color: red;font-weight:bold;">团队推荐</span>里，<span style="color: red;font-weight:bold;">销量最高的蓝牙耳机</span>链接发送给顾客</p>
	          </div>
	        </div>
	        <div id="studytip-nine" class="stoptip">
	          <div class="tip">
	            <span class="el-icon-success"></span>
	            <p>实操通关，进入下一关吧</p>
	            <p>
	              <a class="startstudy" @click="studyNext('#tab-ten', 10, 'ten')">GO，下一关</a>
	            </p>
	          </div>
	        </div>
				</div>
				<div id="tab-ten-content" class="el-tab-pane" :class="{mynone: tabCurrent !== 'ten'}">
					<div id="stoptip-ten" class="stoptip">
	          <div class="tip">
	            <span class="el-icon-success"></span>
	            <p>
	              <a class="startstudy" @click="startStudy">开始实操练习</a>
	            </p>
	          </div>
	        </div>
	        <div id="content-ten" class="content">
	          <div class="con-left">
	            <div class="ddcjbox">
	              <div class="ddcj" v-if="isShowDdcj07">
	                <img src="/tjkStudy/static/newqianniu/ddcj07.jpg" />
	                <div class="ddcj07icon" @mouseover="showDdcj08"></div>
	              </div>
	              <div class="ddcj" v-if="isShowDdcj08">
	                <img src="/tjkStudy/static/newqianniu/ddcj08.jpg" />
	                <div class="ddcj08icon" @click="showDdcj09"></div>
	              </div>
	              <div class="ddcj" v-if="isShowDdcj09">
	                <img src="/tjkStudy/static/newqianniu/ddcj09.jpg" />
	                <el-input class="ddcj09input" v-model.trim="ddcjyf" placeholder=""></el-input>
	                <div class="ddcj09icon" @click="showDdcj10"></div>
	              </div>
	              <div class="ddcj" v-if="isShowDdcjicon">
	                <img src="/tjkStudy/static/newqianniu/ddcj.jpg" />
	                <div class="ddcjicon" @click="showDdcj01"></div>
	              </div>
	              <div class="ddcj" v-if="isShowDdcj01">
	                <img src="/tjkStudy/static/newqianniu/ddcj01.jpg" />
	                <el-input class="ddcj01input" type="textarea" v-model.trim="ddcjbz" placeholder="请填写备注"></el-input>
	                <div class="ddcj01icon" @click="showDdcj02"></div>
	              </div>
	              <div class="ddcj" v-if="isShowDdcj02">
	                <img src="/tjkStudy/static/newqianniu/ddcj02.jpg" />
	                <div class="ddcj02icon" @click="showDdcj03"></div>
	              </div>
	              <div class="ddcj" v-if="isShowDdcj03">
	                <img src="/tjkStudy/static/newqianniu/ddcj03.jpg" />
	                <div class="ddcj03icon" @click="showDdcj04"></div>
	              </div>
	              <div class="ddcj" v-if="isShowDdcj04">
	                <img src="/tjkStudy/static/newqianniu/ddcj04.jpg" />
	                <el-input class="ddcj04input" v-model.trim="ddcjdz" placeholder="请输入地址"></el-input>
	                <div class="ddcj04icon" @click="showDdcj05"></div>
	              </div>
	              <div class="ddcj" v-if="isShowDdcj05">
	                <img src="/tjkStudy/static/newqianniu/ddcj05.jpg" />
	                <div class="ddcj05icon" @click="showDdcj06"></div>
	              </div>
	              <div class="ddcj" v-if="isShowDdcj06">
	                <img src="/tjkStudy/static/newqianniu/ddcj06.jpg" />
	                <input type="text" class="ddcj06input" v-focus="true" @keyup.enter="showDdcj07">
	                <div class="ddcj06icon" @click="showDdcj07"></div>
	              </div>
	              <div class="ddcj" v-if="isShowDdcj10">
	                <img src="/tjkStudy/static/newqianniu/ddcj10.jpg" />
	              </div>
	            </div>
	        	</div>
	        	<div class="con-right">
	            <h3>
	              <span class="line"></span>
	              提示
	            </h3>
	            <p v-if="isShowDdcjTip01">订单插件操作练习：1.请将商品邮费改成<span style="color: red;font-weight:bold;">10</span>元</p>
	            <p v-if="isShowDdcjTip02">订单插件操作练习：2.请点击备注按钮，给此客户添加备注内容“<span style="color: red;font-weight:bold;">顾客要求发顺丰</span>”</p>
	            <p v-if="isShowDdcjTip03">订单插件操作练习：3.请将街道地址修改为“<span style="color: red;font-weight:bold;">双流区大林镇</span>”并核对地址</p>
	        	</div>
	    		</div>
	        <div id="studytip-ten" class="stoptip">
	          <div class="tip">
	            <span class="el-icon-success"></span>
	            <p>实操通关，进入下一关吧</p>
	            <p>
	              <a class="startstudy" @click="studyNext('#tab-eleven', 11, 'eleven')">GO，下一关</a>
	            </p>
	          </div>
	        </div>
				</div>
				<div id="tab-eleven-content" class="el-tab-pane" :class="{mynone: tabCurrent !== 'eleven'}">
					<div id="stoptip-eleven" class="stoptip">
	          <div class="tip">
	            <span class="el-icon-success"></span>
	            <p>
	              <a class="startstudy" @click="startStudy">开始实操练习</a>
	            </p>
	          </div>
	        </div>
	        <div id="content-eleven" class="content">
	          <div class="con-left">
	            <div class="xjrwbox">
	              <div class="xjrw" v-if="isShowXjrwicon">
	                <img src="/tjkStudy/static/newqianniu/xjrw.jpg" />
	                <div class="xjrwicon" @click="showXjrw01"></div>
	              </div>
	              <div class="xjrw" v-if="isShowXjrw01">
	                <img src="/tjkStudy/static/newqianniu/xjrw01.jpg" />
	                <div class="xjrw01icon" @click="showXjrw02"></div>
	              </div>
	              <div class="xjrw" v-if="isShowXjrw02">
	                <img src="/tjkStudy/static/newqianniu/xjrw02.jpg" />
	                <el-input class="xjrw02input" type="textarea" v-model.trim="xjrwtxt" @keyup.ctrl.enter.native="showXjrw06" placeholder="请输入任务内容，按Ctrl+回车键，创建任务"></el-input>
	                <div class="xjrw02icon" @click="showXjrw03"></div>
	              </div>
	              <div class="xjrw" v-if="isShowXjrw03">
	                <img src="/tjkStudy/static/newqianniu/xjrw03.jpg" />
	                <div class="xjrw03icon" @click="showXjrw04"></div>
	              </div>
	              <div class="xjrw" v-if="isShowXjrw04">
	                <img src="/tjkStudy/static/newqianniu/xjrw04.jpg" />
	                <div class="xjrw04icon" @click="showXjrw05"></div>
	              </div>
	              <div class="xjrw" v-if="isShowXjrw05">
	                <img src="/tjkStudy/static/newqianniu/xjrw05.jpg" />
	                <el-date-picker
	                    class="xjrw05input"
	                    v-model="xjrwsj"
	                    type="datetime"
	                    value-format="yyyy-MM-dd HH:mm"
	                    format="yyyy-MM-dd HH:mm"
	                    placeholder="选择日期时间">
	                </el-date-picker>
	                <div class="xjrw05icon" @click="showXjrw06"></div>
	              </div>
	              <div class="xjrw" v-if="isShowXjrw06">
	                <img src="/tjkStudy/static/newqianniu/xjrw06.jpg" />
	              </div>
	         		</div>
	          </div>
	          <div class="con-right">
	            <h3>
	              <span class="line"></span>
	              提示
	            </h3>
	            <p>新建任务操作练习：请给同事“乐乐”新建一个跟进此顾客的任务提醒，任务内容编辑为“<span style="color: red;font-weight:bold;">此顾客有购买意向，请继续跟进</span>”，提醒时间设置为<span style="color: red;font-weight:bold;">{{xjrwmt}}</span></p>
	          </div>
	        </div>
	        <div id="studytip-eleven" class="stoptip">
	          <div class="tip">
	            <span class="el-icon-success"></span>
	            <p>实操通关，进入下一关吧</p>
	            <p>
	              <a class="startstudy" @click="studyNext('#tab-twelve', 12, 'twelve')">GO，下一关</a>
	            </p>
	          </div>
	        </div>
				</div>
				<div id="tab-twelve-content" class="el-tab-pane" :class="{mynone: tabCurrent !== 'twelve'}">
					<div id="stoptip-twelve" class="stoptip">
	          <div class="tip">
	            <span class="el-icon-success"></span>
	            <p>
	              <a class="startstudy" @click="startStudy">开始实操练习</a>
	            </p>
	          </div>
	        </div>
	        <div id="content-twelve" class="content">
	          <div class="con-left">
	            <div class="tcqnbox">
	              <div class="tcqn" v-show="isShowTcqnicon">
	                <img src="/tjkStudy/static/newqianniu/tcqn.jpg" />
	                <div class="tcqnicon" @click="showTcqn01"></div>
	              </div>
	              <div class="tcqn" v-show="isShowTcqn01">
	                <img src="/tjkStudy/static/newqianniu/tcqn01.jpg" />
	                <div class="tcqn01icon" @click="showTcqn02"></div>
	              </div>
	              <div class="tcqn" v-show="isShowTcqn02">
	                <img src="/tjkStudy/static/newqianniu/tcqn02.jpg" />
	                <div class="tcqn02icon" @click="showTcqn03"></div>
	              </div>
	              <div class="tcqn" v-show="isShowTcqn03">
	                <img src="/tjkStudy/static/newqianniu/tcqn03.jpg" />
	                <div class="tcqn03icon" @mouseover="showTcqn04"></div>
	              </div>
	              <div class="tcqn" v-show="isShowTcqn04">
	                <img src="/tjkStudy/static/newqianniu/tcqn04.jpg" />
	                <div class="tcqn04icon" @click="showTcqn05"></div>
	              </div>
	              <div class="tcqn" v-show="isShowTcqn05">
	                <img src="/tjkStudy/static/newqianniu/tcqn05.jpg" />
	                <div class="tcqn05icon" @mouseover="showTcqn06"></div>
	              </div>
	              <div class="tcqn" v-show="isShowTcqn06">
	                <img src="/tjkStudy/static/newqianniu/tcqn06.jpg" />
	                <div class="tcqn06icon" @click="showTcqn07"></div>
	              </div>
	              <div class="tcqn" v-show="isShowTcqn07">
	                <img src="/tjkStudy/static/newqianniu/tcqn07.jpg" />
	                <div class="tcqn07icon" @contextmenu.prevent="showTcqn08"></div>
	              </div>
	              <div class="tcqn" v-show="isShowTcqn08">
	                <img src="/tjkStudy/static/newqianniu/tcqn08.jpg" />
	                <div class="tcqn08icon" @click="showTcqn09"></div>
	              </div>
	              <div class="tcqn" v-show="isShowTcqn09">
	                <img src="/tjkStudy/static/newqianniu/tcqn09.jpg" />
	                <div class="tcqn09icon" @click="showTcqn10"></div>
	              </div>
	              <div class="tcqn" v-show="isShowTcqn10">
	                <img src="/tjkStudy/static/newqianniu/tcqn10.jpg" />
	              </div>
	            </div>
	          </div>
	          <div class="con-right">
	            <h3>
	              <span class="line"></span>
	              提示
	            </h3>
	            <p v-if="isShowTcqnTip01">请先将状态切换为“挂起”</p>
	            <p v-if="isShowTcqnTip02">退出千牛练习：请退出<span style="color: red;font-weight:bold;">左侧练习场</span>中的千牛工作台</p>
	          </div>
	        </div>
	        <div id="studytip-twelve" class="stoptip" v-if="OnInline=='false'">
	          <div class="tip">
	            <span class="el-icon-success"></span>
	            <p>你已完成千牛模拟实操，<br>接下来请完成《京麦功能学习》。</p>
		        <!-- <a class="restart" @click="restartVideoLast"><i class="el-icon-refresh-left"></i>重看视频</a> -->
		        <a class="startstudy" href="/tjkStudy/simulate/jmStudy" style="width: 160px;">去完成京麦功能学习</a>
	          </div>
	        </div>
				</div>
			</div>
		</div>
	 </div>
</template>

<script>
export default {
  data() {
    return {
		OnInline:'false',//小助手跳转
    	tabCurrent: 'first',
    	//第1步
    	isShowQnIcon: true, //是否显示千牛图标
    	isShowQnIcon2: false, //显示点击千牛图标后图片
      isShowLoginImg: false, //是否显示登录图片
      name: '', //登录账号
     	password: '', //密码
     	showPassword: false, //显示账号密码
     	isShowRnd: false, //显示获取随机码
     	rnd: '', //随机密码
     	showRnd: false, //显示随机码
     	isShowLoginIndex: false, //显示登录后图片
     	isShowLoginIndexTwo: false, //显示接待中心
     	//第2步
     	showGqImg: false, //显示切换挂起图片
     	isShowWgq: false, //显示未挂起图片
     	//第3步
     	jdnr: '', //接待回复内容
     	time: this.formatDate(new Date()), 	
     	time1: '', //时间1
     	time2: '', //时间2
     	time3: '', //时间3
     	time4: '', //时间4
     	time5: '', //时间5
     	time6: '', //时间6
     	time7: '', //时间7
     	replyhtml: "<p class='session'><span class='user'>fanchaocdmc</span><span class='time'>"+this.time+"</span></p><p><span>在吗？</span></p>", //回复内容回显1
     	isShowOne: true, //显示回复1
     	isShowTwo: false, //显示回复2
     	isShowThree: false, //显示回复3
     	isShowFour: false, //显示回复4
     	//第4步
     	zdhf: '', //自动回复输入框
     	isShowZdhficon: true,
     	isShowZdhf01: false,
     	isShowZdhf02: false,
     	isShowZdhf03: false,
     	isShowZdhf04: false,
     	isShowZdhf05: false,
     	isShowZdhf06: false,
     	isShowZdhf07: false,
     	isShowZdhf08: false,
     	isShowZdhf09: false,
     	isShowZdhf10: false,
     	//第5步
     	isShowCjxxicon: true,
     	isShowCjxx01: false,
     	isShowCjxx02: false,
     	isShowCjxx03: false,
     	isShowCjxx04: false,
     	isShowCjxx05: false,
     	isShowCjxx06: false,
     	isShowCjxx07: false,
     	isShowCjxx08: false,
     	isShowCjxx09: false,
     	isShowCjxx10: false,
     	isShowCjxx11: false,
     	isShowCjxx12: false,
     	isShowCjxx13: false,
     	isShowCjxx14: false,
     	isShowCjxx15: false,
     	isShowCjxx16: false,
     	isShowCjxx17: false,
     	isShowCjxx18: false,
     	isShowCjxx19: false,
     	isShowCjxx20: false,
     	isShowCjxxTip: true,
     	isShowCjxxTip01: false,
     	isShowCjxxTip02: false,
     	isShowCjxxTip03: false,
     	isShowCjxxTip04: false,
     	isShowCjxxTip05: false,
     	//第6步
     	kjdy: '', //快捷编码输入框
     	downCount: 0, //是否点击下载csv
     	isShowKjdyicon: true,
     	isShowKjdy01: false,
     	isShowKjdy02: false,
     	isShowKjdy03: false,
     	isShowKjdy04: false,
     	isShowKjdy05: false,
     	isShowKjdy06: false,
     	isShowKjdy07: false,
     	isShowKjdy08: false,
     	isShowKjdy09: false,
     	isShowKjdy10: false,
     	isShowKjdy11: false,
     	isShowKjdy12: false,
     	isShowKjdyTip01: true,
     	isShowKjdyTip02: false,
      isShowKjdyTip03: false,
      isShowKjdyTip04: false,
      //第7步
     	isShowZtsbicon: true,
     	isShowZtsb01: false,
     	isShowZtsb02: false,
     	isShowZtsb03: false,
     	isShowZtsb04: false,
     	isShowZtsb05: false,
      isShowZtsb06: false,
      isShowZtsbTip01: true,
     	isShowZtsbTip02: false,
      isShowZtsbTip03: false,
      //第8步
     	isShowZjgnicon: true,
     	isShowZjgn01: false,
     	isShowZjgn02: false,
     	isShowZjgn03: false,
     	isShowZjgn04: false,
      isShowZjgn05: false,
      //第9步
     	isShowTjgnicon: true,
     	isShowTjgn01: false,
     	isShowTjgn02: false,
     	isShowTjgn03: false,
     	isShowTjgn04: false,
     	isShowTjgn05: false,
     	isShowTjgn06: false,
      //第10步
     	isShowDdcjicon: false,
     	isShowDdcj01: false,
     	isShowDdcj02: false,
     	isShowDdcj03: false,
     	isShowDdcj04: false,
     	isShowDdcj05: false,
     	isShowDdcj06: false,
     	isShowDdcj07: true,
     	isShowDdcj08: false,
     	isShowDdcj09: false,
     	isShowDdcj10: false,
      isShowDdcjTip01: true,
     	isShowDdcjTip02: false,
      isShowDdcjTip03: false,
      ddcjbz: '',
      ddcjdz: '',
      ddcjyf: '',
      //第11步
     	isShowXjrwicon: true,
     	isShowXjrw01: false,
     	isShowXjrw02: false,
     	isShowXjrw03: false,
     	isShowXjrw04: false,
     	isShowXjrw05: false,
     	isShowXjrw06: false,
      xjrwmt: this.getLastDaysFromToday(-1) + ' 09:00',
      xjrwsj: '',
      xjrwtxt: '',
      //第12步
     	isShowTcqnicon: true,
     	isShowTcqn01: false,
     	isShowTcqn02: false,
     	isShowTcqn03: false,
     	isShowTcqn04: false,
     	isShowTcqn05: false,
     	isShowTcqn06: false,
     	isShowTcqn07: false,
     	isShowTcqn08: false,
     	isShowTcqn09: false,
     	isShowTcqn10: false,
     	isShowTcqnTip01: true,
     	isShowTcqnTip02: false
    }
  },
  mounted() {
  	$('#stoptip-'+this.tabCurrent).show();
  	this.initAll();
  	var step = this.$route.query.step;
  	if(step == 12){
        this.studyNext('#tab-twelve', step, 'twelve')
	}
  },
  watch: {
  	kjdy: function() {
  		if(this.kjdy == '/结束') {
  			this.isShowKjdy06 = true
  		}
  	}
  },
  directives: {
    focus: {
      inserted: function(el, {value}) {
        if(value){
          el.focus();
        }
      }
    }
  },
    created(){
	  if(this.$route.query.OnInline){
		 this.OnInline=this.$route.query.OnInline  
	  }
  },
  methods: {
  	formatDate: function (value) {
	    let date = new Date(value);
	    let y = date.getFullYear();
	    let MM = date.getMonth() + 1;
	    MM = MM < 10 ? ('0' + MM) : MM;
	    let d = date.getDate();
	    d = d < 10 ? ('0' + d) : d;
	    let h = date.getHours();
	    h = h < 10 ? ('0' + h) : h;
	    let m = date.getMinutes();
	    m = m < 10 ? ('0' + m) : m;
	    let s = date.getSeconds();
	    s = s < 10 ? ('0' + s) : s;
	    return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
	  },
	  //初始化第1步状态值
    initFirst() {
    	this.name = ''
    	this.password = ''
    	this.rnd = ''
    	this.isShowQnIcon = true
    	this.isShowQnIcon2 = false
    	this.isShowLoginImg = false
    	this.showPassword = false
    	this.isShowRnd = false
    	this.showRnd = false
    	this.isShowLoginIndex = false
    	this.isShowLoginIndexTwo = false
    },
    //初始化第2步状态值
    initSecond() {
    	this.showGqImg = false
     	this.isShowWgq = false
    },
    //初始化第3步状态值
    initThird() {
    	this.jdnr = ''
    	this.replyhtml = "<p class='session'><span class='user'>fanchaocdmc</span><span class='time'>"+this.time+"</span></p><p><span>在吗？</span></p>"
    	$('.replyone').html(this.replyhtml);
    	this.time1 = ''
    	this.time2 = ''
    	this.time3 = ''
    	this.time4 = ''
    	this.time5 = ''
    	this.time6 = ''
    	this.time7 = ''
     	this.isShowOne = true
     	this.isShowTwo = false
     	this.isShowThree = false
     	this.isShowFour = false
    },
    //初始化第4步状态值
    initFour() {
    	this.zdhf = ''
     	this.isShowZdhficon = true
     	this.isShowZdhf01 = false
     	this.isShowZdhf02 = false
     	this.isShowZdhf03 = false
     	this.isShowZdhf04 = false
     	this.isShowZdhf05 = false
     	this.isShowZdhf06 = false
     	this.isShowZdhf07 = false
     	this.isShowZdhf08 = false
     	this.isShowZdhf09 = false
      this.isShowZdhf10 = false
    },
    //初始化第5步状态值
    initFive() {
    	this.isShowCjxxicon = true
     	this.isShowCjxx01 = false
     	this.isShowCjxx02 = false
     	this.isShowCjxx03 = false
     	this.isShowCjxx04 = false
     	this.isShowCjxx05 = false
     	this.isShowCjxx06 = false
     	this.isShowCjxx07 = false
     	this.isShowCjxx08 = false
     	this.isShowCjxx09 = false
     	this.isShowCjxx10 = false
     	this.isShowCjxx11 = false
     	this.isShowCjxx12 = false
     	this.isShowCjxx13 = false
     	this.isShowCjxx14 = false
     	this.isShowCjxx15 = false
     	this.isShowCjxx16 = false
     	this.isShowCjxx17 = false
     	this.isShowCjxx18 = false
     	this.isShowCjxx19 = false
     	this.isShowCjxx20 = false
     	this.isShowCjxxTip = true
     	this.isShowCjxxTip01 = false
     	this.isShowCjxxTip02 = false
     	this.isShowCjxxTip03 = false
     	this.isShowCjxxTip04 = false
     	this.isShowCjxxTip05 = false
    },
    //初始化第6步状态值
    initSix() {
    	this.kjdy = ''
     	this.downCount = 0
     	this.isShowKjdyicon = true
     	this.isShowKjdy01 = false
     	this.isShowKjdy02 = false
     	this.isShowKjdy03 = false
     	this.isShowKjdy04 = false
     	this.isShowKjdy05 = false
     	this.isShowKjdy06 = false
     	this.isShowKjdy07 = false
     	this.isShowKjdy08 = false
     	this.isShowKjdy09 = false
     	this.isShowKjdy10 = false
     	this.isShowKjdy11 = false
     	this.isShowKjdy12 = false
     	this.isShowKjdyTip01 = true
     	this.isShowKjdyTip02 = false
     	this.isShowKjdyTip03 = false
     	this.isShowKjdyTip04 = false
    },
    //初始化第7步状态值
    initSeven() {
     	this.isShowZtsbicon = true
     	this.isShowZtsb01 = false
     	this.isShowZtsb02 = false
     	this.isShowZtsb03 = false
     	this.isShowZtsb04 = false
     	this.isShowZtsb05 = false
      this.isShowZtsb06 = false
      this.isShowZtsbTip01 = true;
      this.isShowZtsbTip02 = false;
      this.isShowZtsbTip03 = false;
    },
    //初始化第8步状态值
    initEight() {
     	this.isShowZjgnicon = true
     	this.isShowZjgn01 = false
     	this.isShowZjgn02 = false
     	this.isShowZjgn03 = false
     	this.isShowZjgn04 = false
     	this.isShowZjgn05 = false
    },
    //初始化第9步状态值
    initNine() {
     	this.isShowTjgnicon = true
     	this.isShowTjgn01 = false
     	this.isShowTjgn02 = false
     	this.isShowTjgn03 = false
     	this.isShowTjgn04 = false
     	this.isShowTjgn05 = false
     	this.isShowTjgn06 = false
    },
    //初始化第10步状态值
    initTen() {
     	this.isShowDdcjicon = false
     	this.isShowDdcj01 = false
     	this.isShowDdcj02 = false
     	this.isShowDdcj03 = false
     	this.isShowDdcj04 = false
     	this.isShowDdcj05 = false
     	this.isShowDdcj06 = false
     	this.isShowDdcj07 = true
     	this.isShowDdcj08 = false
     	this.isShowDdcj09 = false
     	this.isShowDdcj10 = false
      this.isShowDdcjTip01 = true 
      this.isShowDdcjTip02 = false 
      this.isShowDdcjTip03 = false 
      this.ddcjbz = ''
      this.ddcjdz = ''
      this.ddcjyf = ''
    },
    //初始化第11步状态值
    initEleven() {
     	this.isShowXjrwicon = true
     	this.isShowXjrw01 = false
     	this.isShowXjrw02 = false
     	this.isShowXjrw03 = false
     	this.isShowXjrw04 = false
     	this.isShowXjrw05 = false
     	this.isShowXjrw06 = false
      this.xjrwmt = this.getLastDaysFromToday(-1) + ' 09:00'
      this.xjrwsj = ''
      this.xjrwtxt = ''
    },
    //初始化第12步状态值
    initTwelve() {
     	this.isShowTcqnicon = true
     	this.isShowTcqn01 = false
     	this.isShowTcqn02 = false
     	this.isShowTcqn03 = false
     	this.isShowTcqn04 = false
     	this.isShowTcqn05 = false
     	this.isShowTcqn06 = false
     	this.isShowTcqn07 = false
     	this.isShowTcqn08 = false
     	this.isShowTcqn09 = false
     	this.isShowTcqn10 = false
     	this.isShowTcqnTip01 = true
     	this.isShowTcqnTip02 = false
    },
  	//初始化所有tab内容
  	initAll() {
    	//第1步
    	this.initFirst()
     	//第2步
     	this.initSecond()
     	//第3步
     	this.initThird()
     	//第4步
     	this.initFour()
     	//第5步
     	this.initFive()
     	//第6步
      this.initSix()
      //第7步
      this.initSeven()
      //第8步
      this.initEight()
      //第9步
      this.initNine()
      //第10步
      this.initTen()
      //第11步
      this.initEleven()
      //第12步
      this.initTwelve()
  	},
    //开始实操练习
    startStudy() {
    	$('#stoptip-'+this.tabCurrent).hide();
    	$('#content-'+this.tabCurrent).show();
    	this.addRecord('START', 1);
    },
    //下一关
    studyNext(next, index, tabCurrent) {
    	$('.el-tabs__header').find('.js-tab').each(function() {
    		$(this).removeClass('is-active');
    	});
    	$(next).addClass('is-active');
    	$('.el-tabs__content').find('.el-tab-pane').each(function() {
    		$(this).hide();
    	});
    	$(next+'-content').show();
    	this.tabCurrent = tabCurrent;
    	this.addRecord('START', index);
    },
    //第1步-单击千牛图标
    showLoginImg() {
    	this.isShowQnIcon = false
    	this.isShowQnIcon2 = true
    },
    //双击千牛图标
    showLoginImg2() {
    	this.isShowQnIcon2 = false
    	this.isShowLoginImg = true
    },
    //登录
    loginIn() {
      if(this.name == '') {
        this.notify('<p>请输入账号</p>')
        return
      }else if(this.name != '淘金客服:001') {
        this.notify('<p>用户名或密码错误</p>'+'<p>请注意大小写或特殊符号</p>')
        return
      }
      if(this.password == '') {
        this.notify('<p>请输入密码</p>')
        return
      }else if(this.password != 'TJ2019') {
        this.notify('<p>用户名或密码错误</p>'+'<p>请注意大小写或特殊符号</p>')
        return
      }
      this.isShowLoginImg = false
      this.isShowRnd = true
    },
    //验证码登录
    loginInRnd() {
    	if(this.rnd == '') {
        this.notify('<p>请输入短信验证码</p>')
        return
      }else if(this.rnd != '660220') {
        this.notify('<p>短信验证码错误</p>')
        return
      }
      this.isShowRnd = false
      this.isShowLoginIndex = true
    },
    //进入接待中心
    enterJd() {
    	var self = this
    	this.isShowLoginIndex = false
    	this.isShowLoginIndexTwo = true
    	this.addRecord('END', 1)
    	setTimeout(function() {
        $('#studytip-'+self.tabCurrent).show();
      }, 2000);
    },
    //第2步-切换状态-显示未挂起图片
    showWgqImg() {
    	var self = this
    	this.showGqImg = false
    	this.isShowWgq = true
    	this.addRecord('END', 2);
    	setTimeout(function() {
        $('#studytip-'+self.tabCurrent).show();
      }, 2000);
    },
    //第3步-接待顾客
    //监听回车1
    listenOne(event) {
	    if(event.keyCode === 13) {
        this.showJieDaiImgOne()
        event.preventDefault()
        return false
	    }
		},
		//监听回车2
    listenTwo(event) {
	    if(event.keyCode === 13) {
        this.showJieDaiImgTwo()
        event.preventDefault()
        return false
	    }
		},
		//监听回车3
		listenThree() {
			if(event.keyCode === 13) {
        this.showJieDaiImgThree()
        event.preventDefault()
        return false
	    }
		},
		//监听回车4
		listenFour() {
			if(event.keyCode === 13) {
        this.showJieDaiImgFour()
        event.preventDefault()
        return false
	    }
		},
    //接待顾客-显示回复1
    showJieDaiImgOne() {
    	let self = this
    	if(this.jdnr.indexOf('您好')<0 || this.jdnr.indexOf('欢迎光临')<0 || this.jdnr.indexOf('请问有什么可以帮到您')<0) {
        this.notify('<p>请按照右边提示输入正确的回复内容</p>')
        return
      }
      this.time1 = this.formatDate(new Date());
      this.replyhtml = "<p class='session'><span class='user'>fanchaocdmc</span><span class='time'>"+this.time+"</span></p><p><span>在吗？</span></p><p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>"+this.time1+"</span></p><p><span>您好！欢迎光临，请问有什么可以帮到您？</span><span class='read'>已读</span></p>";
      $('.replyone').html(this.replyhtml);
      setTimeout(function() {
      	self.time2 = self.formatDate(new Date());
        self.replyhtml = "<p class='session'><span class='user'>fanchaocdmc</span><span class='time'>"+self.time+"</span></p><p><span>在吗？</span></p><p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>"+self.time1+"</span></p><p><span>您好！欢迎光临，请问有什么可以帮到您？</span><span class='read'>已读</span></p><p class='session'><span class='user'>fanchaocdmc</span><span class='time'>"+self.time2+"</span></p><p><span>我今天下单的话，寄成都什么时候能收到呢？</span></p>";
        $('.replyone').html(self.replyhtml);
        self.isShowOne = false;
    		self.isShowTwo = true;
      }, 2000);
    	this.jdnr = ''
    },
    //接待顾客-显示回复2
    showJieDaiImgTwo() {
    	let self = this
    	if(this.jdnr.indexOf('亲亲')<0 || this.jdnr.indexOf('正常情况下大概3天左右能到哦')<0) {
        this.notify('<p>请按照右边提示输入正确的回复内容</p>')
        return
      }
      this.time3 = this.formatDate(new Date());
      this.replyhtml = "<p class='session'><span class='user'>fanchaocdmc</span><span class='time'>"+this.time+"</span></p><p><span>在吗？</span></p><p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>"+this.time1+"</span></p><p><span>您好！欢迎光临，请问有什么可以帮到您？</span><span class='read'>已读</span></p><p class='session'><span class='user'>fanchaocdmc</span><span class='time'>"+this.time2+"</span></p><p><span>我今天下单的话，寄成都什么时候能收到呢？</span></p><p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>"+this.time3+"</span></p><p><span>亲亲，正常情况下大概3天左右能到哦！</span><span class='read'>已读</span></p>";
      $('.replyone').html(this.replyhtml);
      setTimeout(function() {
      	self.time4 = self.formatDate(new Date());
        self.replyhtml = "<p class='session'><span class='user'>fanchaocdmc</span><span class='time'>"+self.time+"</span></p><p><span>在吗？</span></p><p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>"+self.time1+"</span></p><p><span>您好！欢迎光临，请问有什么可以帮到您？</span><span class='read'>已读</span></p><p class='session'><span class='user'>fanchaocdmc</span><span class='time'>"+self.time2+"</span></p><p><span>我今天下单的话，寄成都什么时候能收到呢？</span></p><p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>"+self.time3+"</span></p><p><span>亲亲，正常情况下大概3天左右能到哦！</span><span class='read'>已读</span></p><p class='session'><span class='user'>fanchaocdmc</span><span class='time'>"+self.time4+"</span></p><p><span>好的</span></p>";
        $('.replyone').html(self.replyhtml);
        self.isShowTwo = false;
    		self.isShowThree = true;
      }, 2000);
    	this.jdnr = ''
    },
    //接待顾客-显示回复3
    showJieDaiImgThree() {
    	let self = this
    	if(this.jdnr.indexOf('请问还有什么可以帮到您')<0) {
        this.notify('<p>请按照右边提示输入正确的回复内容</p>')
        return
      }
      this.time5 = this.formatDate(new Date());
      this.replyhtml = "<p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>"+this.time1+"</span></p><p><span>您好！欢迎光临，请问有什么可以帮到您？</span><span class='read'>已读</span></p><p class='session'><span class='user'>fanchaocdmc</span><span class='time'>"+this.time2+"</span></p><p><span>我今天下单的话，寄成都什么时候能收到呢？</span></p><p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>"+this.time3+"</span></p><p><span>亲亲，正常情况下大概3天左右能到哦！</span><span class='read'>已读</span></p><p class='session'><span class='user'>fanchaocdmc</span><span class='time'>"+this.time4+"</span></p><p><span>好的</span></p><p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>"+this.time5+"</span></p><p><span>请问还有什么可以帮到您？</span><span class='read'>已读</span></p>";
      $('.replyone').html(this.replyhtml);
      setTimeout(function() {
      	self.time6 = self.formatDate(new Date());
        self.replyhtml = "<p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>"+self.time1+"</span></p><p><span>您好！欢迎光临，请问有什么可以帮到您？</span><span class='read'>已读</span></p><p class='session'><span class='user'>fanchaocdmc</span><span class='time'>"+self.time2+"</span></p><p><span>我今天下单的话，寄成都什么时候能收到呢？</span></p><p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>"+self.time3+"</span></p><p><span>亲亲，正常情况下大概3天左右能到哦！</span><span class='read'>已读</span></p><p class='session'><span class='user'>fanchaocdmc</span><span class='time'>"+self.time4+"</span></p><p><span>好的</span></p><p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>"+self.time5+"</span></p><p><span>请问还有什么可以帮到您？</span><span class='read'>已读</span></p><p class='session'><span class='user'>fanchaocdmc</span><span class='time'>"+self.time6+"</span></p><p><span>没有了</span></p>";
        $('.replyone').html(self.replyhtml);
        self.isShowThree = false;
    		self.isShowFour = true;
      }, 2000);
    	this.jdnr = ''
    },
    //接待顾客-显示回复4
    showJieDaiImgFour() {
    	let self = this
    	if(this.jdnr.indexOf('好的')<0 || this.jdnr.indexOf('感谢亲亲的支持')<0 || this.jdnr.indexOf('祝您生活愉快')<0) {
        this.notify('<p>请按照右边提示输入正确的回复内容</p>')
        return
      }
      this.time7 = this.formatDate(new Date());
      this.replyhtml = "<p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>"+this.time1+"</span></p><p><span>您好！欢迎光临，请问有什么可以帮到您？</span><span class='read'>已读</span></p><p class='session'><span class='user'>fanchaocdmc</span><span class='time'>"+this.time2+"</span></p><p><span>我今天下单的话，寄成都什么时候能收到呢？</span></p><p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>"+this.time3+"</span></p><p><span>亲亲，正常情况下大概3天左右能到哦！</span><span class='read'>已读</span></p><p class='session'><span class='user'>fanchaocdmc</span><span class='time'>"+this.time4+"</span></p><p><span>好的</span></p><p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>"+this.time5+"</span></p><p><span>请问还有什么可以帮到您？</span><span class='read'>已读</span></p><p class='session'><span class='user'>fanchaocdmc</span><span class='time'>"+this.time6+"</span></p><p><span>没有了</span></p><p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>"+this.time7+"</span></p><p><span>好的，感谢亲亲的支持，祝您生活愉快</span><span class='read'>已读</span></p>";
      $('.replyone').html(this.replyhtml);
    	this.jdnr = ''
    	this.addRecord('END', 3)
    	setTimeout(function() {
        $('#studytip-'+self.tabCurrent).show();
      }, 2000);
    },
    //第4步-自动回复
    showZdhf01() {
    	this.isShowZdhficon = false
    	this.isShowZdhf01 = true
    	var $zdhficon = $('.zdhficon').closest('.con-left'),
        	height = $('.zdhficon').closest('.con-left')[0].scrollHeight;
    	setTimeout(() => {
        $zdhficon.scrollTop(height)
      }, 100)
    },
    showZdhf02() {
    	this.isShowZdhf01 = false
    	this.isShowZdhf02 = true
    },
    showZdhf03() {
    	this.isShowZdhf02 = false
    	this.isShowZdhf03 = true
    },
    showZdhf04() {
    	this.isShowZdhf03 = false
    	this.isShowZdhf04 = true
    },
    showZdhf05() {
    	this.isShowZdhf04 = false
    	this.isShowZdhf05 = true
    },
    showZdhf06() {
    	if(this.zdhf.indexOf('您好')<0 || this.zdhf.indexOf('欢迎光临')<0 || this.zdhf.indexOf('请问有什么可以帮到您')<0) {
        this.notify('<p>请按照右边提示输入正确的回复内容</p>')
        return
      }
    	this.isShowZdhf05 = false
    	this.zdhf = ''
    	this.isShowZdhf06 = true
    },
    showZdhf07() {
    	this.isShowZdhf06 = false
    	this.isShowZdhf07 = true
    },
    showZdhf08() {
    	this.isShowZdhf07 = false
    	this.isShowZdhf08 = true
    },
    showZdhf09() {
    	this.isShowZdhf08 = false
    	this.isShowZdhf09 = true
    },
    showZdhf10() {
    	let self = this
    	this.isShowZdhf09 = false
    	this.isShowZdhf10 = true
    	this.addRecord('END', 4)
    	setTimeout(function() {
        $('#studytip-'+self.tabCurrent).show();
      }, 2000);
    },
    //第5步-插件学习
    showCjxx01() {
    	this.isShowCjxxicon = false
    	this.isShowCjxx01 = true
    },
    showCjxx02() {
    	this.isShowCjxx01 = false
    	this.isShowCjxx02 = true
    },
    showCjxx03() {
    	this.isShowCjxx02 = false
    	this.isShowCjxx03 = true
    	this.isShowCjxxTip = false
    	this.isShowCjxxTip01 = true
    },
    showCjxx04() {
    	this.isShowCjxx03 = false
    	this.isShowCjxx04 = true
    },
    showCjxx05() {
    	this.isShowCjxx04 = false
    	this.isShowCjxx05 = true
    },
    showCjxx06() {
    	this.isShowCjxx05 = false
      this.isShowCjxx06 = true
      this.isShowCjxxTip01 = false
    	this.isShowCjxxTip02 = true
    },
    showCjxx07() {
    	this.isShowCjxx06 = false
      this.isShowCjxx07 = true
    },
    showCjxx08() {
    	this.isShowCjxx07 = false
    	this.isShowCjxx08 = true
    },
    showCjxx09() {
    	this.isShowCjxx08 = false
    	this.isShowCjxx09 = true
    },
    showCjxx10() {
    	this.isShowCjxx09 = false
      this.isShowCjxx10 = true
      this.isShowCjxxTip02 = false
    	this.isShowCjxxTip03 = true
    },
    showCjxx11() {
    	this.isShowCjxx10 = false
    	this.isShowCjxx11 = true
    },
    showCjxx12() {
    	this.isShowCjxx11 = false
    	this.isShowCjxx12 = true
    },
    showCjxx13() {
    	this.isShowCjxx12 = false
    	this.isShowCjxx13 = true
    },
    showCjxx14() {
    	this.isShowCjxx13 = false
      this.isShowCjxx14 = true
      this.isShowCjxxTip03 = false
    	this.isShowCjxxTip04 = true
    },
    showCjxx15() {
    	this.isShowCjxx14 = false
    	this.isShowCjxx15 = true
    },
    showCjxx16() {
    	this.isShowCjxx15 = false
    	this.isShowCjxx16 = true
    },
    showCjxx17() {
    	this.isShowCjxx16 = false
    	this.isShowCjxx17 = true
    },
    showCjxx18() {
    	this.isShowCjxx17 = false
    	this.isShowCjxx18 = true
    	this.isShowCjxxTip04 = false
    	this.isShowCjxxTip05 = true
    },
    showCjxx19() {
    	this.isShowCjxx18 = false
    	this.isShowCjxx19 = true
    },
    showCjxx20() {
    	this.isShowCjxx19 = false
      this.isShowCjxx20 = true
      let self = this;
      this.addRecord('END', 5)
      setTimeout(function() {
        $('#studytip-'+self.tabCurrent).show();
      }, 2000);
    },
    //第6步-快捷短语
    showKjdy01() {
    	this.isShowKjdyicon = false
    	this.isShowKjdy01 = true
    },
    showKjdy02() {
    	this.isShowKjdy01 = false
    	this.isShowKjdy02 = true
    },
    showKjdy03() {
    	this.isShowKjdy02 = false
    	this.isShowKjdy03 = true
    },
    showKjdy04() {
    	let self = this
    	this.isShowKjdy03 = false
    	this.isShowKjdy04 = true
    	this.notify('<p>快捷短语鼠标点击练习完成，下一步快捷短语编码练习</p>')
    	setTimeout(function() {
        self.isShowKjdyTip01 = false
        self.isShowKjdyTip02 = true
        self.isShowKjdy04 = false
        self.isShowKjdy05 = true
      }, 2000);
    },
    showKjdy05() {
    	this.isShowKjdy05 = false
    	this.isShowKjdy06 = false
    	this.isShowKjdy07 = true
    },
    showKjdy06() {
    	let self = this
    	this.isShowKjdy07 = false
    	this.isShowKjdy08 = true
    	this.notify('<p>快捷短语编码练习完成，下一步快捷模板导入练习</p>')
    	setTimeout(function() {
        self.isShowKjdyTip02 = false
        self.isShowKjdyTip03 = true
        self.isShowKjdy08 = false
    		self.isShowKjdy09 = true
      }, 2000);
    },
    downloadKjdyFile() {
    	this.downCount = 1
    	// window.open('//taojinyun.file.itaojin.cn/qianniusource/快捷短语.csv')
		 let path = '//taojinyun.file.itaojin.cn/qianniusource/快捷短语.csv'
      const downloadRes = async () => {
          let response = await fetch(path); 
          let blob = await response.blob();  
          let objectUrl = window.URL.createObjectURL(blob);
          let a = document.createElement('a');
          a.href = objectUrl;
          a.download = '快捷短语.csv';
          a.click()
          a.remove(); 
       }
      downloadRes();

    	this.isShowKjdyTip03 = false
    	this.isShowKjdyTip04 = true
    },
    showKjdy07() {
    	if(this.downCount == 0) {
    		this.$alert('请先下载快捷短语模板')
    		return false
    	}
    	this.isShowKjdy09 = false
    	this.isShowKjdy10 = true
    },
    tirggerFile($event) {
    	let self = this
      var file = $event.target.files;
    	if(!file[0] || file[0] && file[0].name.indexOf('快捷短语')<0) {
    		this.$alert('请选择你下载的“快捷短语.csv”模板文件')
    		return false
    	}
    	setTimeout(function() {
        self.isShowKjdy10 = false
        self.isShowKjdy11 = true
      }, 500);
    },
    showKjdy08() {
    	let self = this
    	this.isShowKjdy11 = false
    	this.isShowKjdy12 = true
    	this.addRecord('END', 6)
    	setTimeout(function() {
        $('#studytip-'+self.tabCurrent).show();
      }, 2000);
    },
    //第7步-状态识别
    showZtsb01() {
    	this.isShowZtsbicon = false
    	this.isShowZtsb01 = true
    },
    showZtsb02() {
    	this.isShowZtsb01 = false
      this.isShowZtsb02 = true
      this.isShowZtsbTip01 = false
      this.isShowZtsbTip02 = true
    },
    showZtsb03() {
    	this.isShowZtsb02 = false
      this.isShowZtsb03 = true
    },
    showZtsb04() {
    	this.isShowZtsb03 = false
      this.isShowZtsb04 = true
      this.isShowZtsbTip02 = false
      this.isShowZtsbTip03 = true
    },
    showZtsb05() {
    	this.isShowZtsb04 = false
      this.isShowZtsb05 = true
    },
    showZtsb06() {
    	this.isShowZtsb05 = false
      this.isShowZtsb06 = true
      let self = this
    	this.isShowKjdy11 = false
    	this.isShowKjdy12 = true
    	this.addRecord('END', 7)
    	setTimeout(function() {
        $('#studytip-'+self.tabCurrent).show();
      }, 2000);
    },
    //第8步-转接功能
    showZjgn01() {
    	this.isShowZjgnicon = false
    	this.isShowZjgn01 = true
    },
    showZjgn02() {
    	this.isShowZjgn01 = false
      this.isShowZjgn02 = true
      this.isShowZjgnTip01 = false
      this.isShowZjgnTip02 = true
    },
    showZjgn03() {
    	this.isShowZjgn02 = false
      this.isShowZjgn03 = true
    },
    showZjgn04() {
    	this.isShowZjgn03 = false
      this.isShowZjgn04 = true
    },
    showZjgn05() {
    	this.isShowZjgn04 = false
      this.isShowZjgn05 = true
      let self = this
    	this.addRecord('END', 8)
    	setTimeout(function() {
        $('#studytip-'+self.tabCurrent).show();
      }, 2000);
    },
    //第9步-商品插件（推荐功能）
    showTjgn01() {
    	this.isShowTjgnicon = false
    	this.isShowTjgn01 = true
    },
    showTjgn02() {
    	this.isShowTjgn01 = false
      this.isShowTjgn02 = true
    },
    showTjgn03() {
    	this.isShowTjgn02 = false
      this.isShowTjgn03 = true
    },
    showTjgn04() {
    	this.isShowTjgn03 = false
      this.isShowTjgn04 = true
    },
    showTjgn05() {
    	this.isShowTjgn04 = false
      this.isShowTjgn05 = true
    },
    showTjgn06() {
    	this.isShowTjgn05 = false
      this.isShowTjgn06 = true
      let self = this
    	this.addRecord('END', 9)
    	setTimeout(function() {
        $('#studytip-'+self.tabCurrent).show();
      }, 2000);
    },
    //第10步-订单插件
    showDdcj01() {
    	this.isShowDdcjicon = false
    	this.isShowDdcj01 = true
    },
    showDdcj02() {
    	if(this.ddcjbz == '') {
    		this.notify('<p>你还没有填写订单备注</p>')
        return;
    	}
      if(this.ddcjbz != '顾客要求发顺丰') {
        this.notify('<p>请按照右边提示填写正确的订单备注</p>')
        return;
      }
    	this.isShowDdcj01 = false
      this.isShowDdcj02 = true
      this.isShowDdcjTip02 = false
      this.isShowDdcjTip03 = true
    },
    showDdcj03() {
    	this.isShowDdcj02 = false
      this.isShowDdcj03 = true
    },
    showDdcj04() {
    	this.isShowDdcj03 = false
      this.isShowDdcj04 = true
    },
    showDdcj05() {
    	if(this.ddcjdz == '') {
    		this.notify('<p>你还没有填写地址</p>')
        return;
    	}
     if(this.ddcjdz == "双流区 大林镇" || this.ddcjdz == "双流区大林镇" ) {
		 
      }else{
		   console.log(this.ddcjdz=='双流区 大林镇')
        this.notify('<p>请按照右边提示填写正确的地址</p>')
        return;
	  }
    	this.isShowDdcj04 = false
      this.isShowDdcj05 = true
    },
    showDdcj06() {
    	this.isShowDdcj05 = false
      this.isShowDdcj06 = true
    },
    showDdcj08() {
    	this.isShowDdcj10 = false
      this.isShowDdcj08 = true
    },
    showDdcj09() {
    	this.isShowDdcj08 = false
      this.isShowDdcj09 = true
    },
    showDdcj10() {
    	if(this.ddcjyf == '') {
    		this.notify('<p>你还没有填写邮费</p>')
        return;
    	}
      if(this.ddcjyf != '10') {
        this.notify('<p>请按照右边提示填写正确的邮费</p>')
        return;
      }
    	this.isShowDdcj09 = false
      this.isShowDdcjicon = true
      this.isShowDdcjTip01 = false
      this.isShowDdcjTip02 = true
    },
    showDdcj07() {
    	this.isShowDdcj06 = false
      this.isShowDdcj10 = true
      let self = this
    	this.addRecord('END', 10)
    	setTimeout(function() {
        $('#studytip-'+self.tabCurrent).show();
      }, 2000);
    },
    //第11步-新建任务
    showXjrw01() {
    	this.isShowXjrwicon = false
    	this.isShowXjrw01 = true
    },
    showXjrw02() {
    	this.isShowXjrw01 = false
      this.isShowXjrw02 = true
    },
    showXjrw03() {
      if(this.xjrwtxt.indexOf('此顾客有购买意向')<0 || this.xjrwtxt.indexOf('请继续跟进')<0) {
        this.notify('<p>请按照右边提示填写正确的任务内容</p>')
        return;
      }
    	this.isShowXjrw02 = false
      this.isShowXjrw03 = true
    },
    showXjrw04() {
    	this.isShowXjrw03 = false
      this.isShowXjrw04 = true
    },
    showXjrw05() {
    	this.isShowXjrw04 = false
      this.isShowXjrw05 = true
    },
    showXjrw06() {
      if(this.xjrwsj != this.xjrwmt) {
        this.notify('<p>请按照右边提示设置正确的时间</p>')
        return;
      }
    	this.isShowXjrw05 = false
      this.isShowXjrw06 = true
      let self = this
    	this.addRecord('END', 11)
    	setTimeout(function() {
        $('#studytip-'+self.tabCurrent).show();
      }, 2000);
    },
    //第12步-退出千牛
    showTcqn01() {
    	this.isShowTcqnicon = false
    	this.isShowTcqn01 = true
    },
    showTcqn02() {
    	this.isShowTcqn01 = false
      this.isShowTcqn02 = true
      this.isShowTcqnTip01 = false
      this.isShowTcqnTip02 = true
    },
    showTcqn03() {
    	this.isShowTcqn02 = false
      this.isShowTcqn03 = true
    },
    showTcqn04() {
    	this.isShowTcqn03 = false
      this.isShowTcqn04 = true
    },
    showTcqn05() {
    	this.isShowTcqn04 = false
      this.isShowTcqn05 = true
      setTimeout(() => {
        var $left = $('.tcqn05icon').closest('.con-left');
        $left.scrollTop($left[0].scrollHeight)
      }, 100)
    },
    showTcqn06() {
    	this.isShowTcqn05 = false
      this.isShowTcqn06 = true
    },
    showTcqn07() {
    	this.isShowTcqn06 = false
    	this.isShowTcqn07 = true
    },
    showTcqn08() {
    	this.isShowTcqn07 = false
      this.isShowTcqn08 = true
    },
    showTcqn09() {
    	this.isShowTcqn08 = false
      this.isShowTcqn09 = true
    },
    showTcqn10() {
    	this.isShowTcqn09 = false
      this.isShowTcqn10 = true
      let self = this
    	this.addRecord('END', 12)
    	setTimeout(function() {
        $('#studytip-'+self.tabCurrent).show();
      }, 2000);
    },
    /*
     * @description 时间格式化
     * @param { date } date 时间或时间戳
     * @param { string } format 格式化的字符串 eg: 'yyyy:MM:dd hh:mm:ss'
     *
     * @return { string } 格式化后的字符串
    */
    dateFormatString (date, format) { // 时间格式化
      var date = new Date(date),
        o = {
          "M+" : date.getMonth() + 1,
          "d+" : date.getDate(),
          "h+" : date.getHours(),
          "m+" : date.getMinutes(),
          "s+" : date.getSeconds(),
          "q+" : Math.floor((date.getMonth() + 3) / 3),
          "S" : date.getMilliseconds()
        };
      if (/(y+)/.test(format)) {
        format = format.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
      }
      
      for (var k in o) {
        if (new RegExp("(" + k + ")").test(format)) {
          format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
        }
      }
      return format;
    },
    /**
     * 获取从今日开始的前 n 天的日期
     */
    getLastDaysFromToday(n){
      let lastDays = new Date().setDate((new Date().getDate() - n));
      let lastDaysStr = this.dateFormatString(lastDays, 'yyyy-MM-dd');
      return lastDaysStr;
    },
    //记录接口
    addRecord(type, index) {
      var data = {
        exerciseType: 'QIAN_NIU_EXAM_11618',
        stepSeq: index,
        exerciseAction: type
      }
      this.$http.post(API_ROOT.newcustomer + '/simulationExercise/addRecord', data).then(res=> {
        var result = res.data
        if(result.success) {
           if(index==12 && type=='END'){
		    window.parent['goBack']();
		  }
        }else {
          this.$message({
            message: result.msg,
            type: 'error',
            center: true,
            duration: 1000
          })
        }
      },res=> {
        this.$message({
          message: "网络繁忙，请稍后重试！",
          type: 'error',
          center: true,
          duration: 1000
        })
      })
    }
  } 
}
</script>
<style lang="less" scoped>
.account-table {
  border-top: 1px solid #000000;
  border-left: 1px solid #000000;
  margin: 10px;
  border-spacing: inherit;
  > tr > td {
    border-right: 1px solid #000000;
    border-bottom: 1px solid #000000;
    padding: 5px;
  }
}
.mynone {
    display: none !important;
}
</style>


// WEBPACK FOOTER //
// ./src/page/simulate/newQianNiuExam_11618.vue